/**
 * @author Iulian Ceapa <dev@sitemd.net>
 * @copyright © 2019-2026 SiteMD.
 */

SmoothScroll();

function checkScreenWidth() {
    const viewport = document.querySelector('meta[name="viewport"]');
    viewport.setAttribute('content', 'width=' + (screen.width <= 340 ? '340' : 'device-width, height=device-height, initial-scale=1'));
}

window.addEventListener('DOMContentLoaded', checkScreenWidth);
window.addEventListener('resize', checkScreenWidth);

// Mutarea meniului in offcanvas pentru telefon
$(document).ready(function () {
    function moveNavbar() {
        if ($(window).width() < 768) {
            $('.navbar-nav .nav-item').appendTo('.offcanvas .nav');
        } else {
            if (!$('.navbar-nav').has('.nav-item').length) {
                $('.offcanvas .nav .nav-item').appendTo('.navbar-nav');
                bootstrap.Offcanvas.getInstance($('#menu')).hide();
            }
        }
    }

    moveNavbar();

    $(window).resize(function () {
        moveNavbar();
    });
});

$(function () {
    let prev_scroll = window.scrollY;
    const header = $('header');
    const header_logo = $('.navbar-brand img');
    const hide_threshold = 100;

    const default_logo = window.location.origin + "/dist/app/media/img/logo-white.svg";
    const fixed_logo = window.location.origin + "/dist/app/media/img/logo-dark.svg";

    // Initial setup if the scroll position is not at 0
    if (prev_scroll > 0) {
        header.addClass('header-fixed');
        header_logo.attr('src', fixed_logo);
    }

    $(window).scroll(function () {
        let current_scroll = window.scrollY;

        // Handling negative scroll values (Safari macOS)
        current_scroll = Math.max(0, current_scroll);
        prev_scroll = Math.max(0, prev_scroll);

        // Hiding or displaying the menu based on the scroll direction
        if (current_scroll > hide_threshold && current_scroll > prev_scroll) {
            header.addClass('hide');
        } else {
            header.removeClass('hide').addClass('header-fixed');
            header_logo.attr('src', fixed_logo);
            if (current_scroll === 0) {
                header.removeClass('header-fixed');
                header_logo.attr('src', default_logo);
            }
        }
        prev_scroll = current_scroll;
    });
});

const mask_phone = document.querySelectorAll('form input[name="phone"]');
if (mask_phone) {
    mask_phone.forEach(phone => {
        window.intlTelInput(phone, {
            autoPlaceholder: 'off',
            hiddenInput: phone.name,
            initialCountry: 'md',
            preferredCountries: ['md', 'ro'],
            separateDialCode: true,
            utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js',
        });
    });
}

document.querySelectorAll('.anchor').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
        let target = this.getAttribute('href');
        if (target) {
            gsap.to(window, {
                duration: 0,
                scrollTo: { y: target }
            });
        }

        // Menu
        if ($('.navbar-toggler-icon').hasClass('active')) {
            $('.navbar-toggler-icon').removeClass('active');
            bootstrap.Offcanvas.getInstance($('#menu')).hide();
        }
    });
});

// Animație automată a taburilor cu tipurile de duplexuri pe versiunea mobilă
const duplex_header_tabs = document.querySelector('.duplexes-header__types');

let scroll_hint_timer;
let user_interacted_tabs = false;

function showScrollHint() {
    if (user_interacted_tabs) return;

    duplex_header_tabs.scrollTo({
        left: 30,
        behavior: 'smooth'
    });

    setTimeout(() => {
        if (!user_interacted_tabs) {
            duplex_header_tabs.scrollTo({
                left: 0,
                behavior: 'smooth'
            });
        }
    }, 500);
}

scroll_hint_timer = setInterval(showScrollHint, 2000);

// Detectăm interacțiunea utilizatorului
[
    'touchstart',
    'mousedown',
    'wheel'
].forEach(event => {
    duplex_header_tabs.addEventListener(event, () => {
        user_interacted_tabs = true;
    }, { once: true });
});
// END animation

// Funcțional pentru mutarea descrierii și butonului download la telefon
const duplex_intro = document.querySelector(".duplex-details__intro");
const duplex_btn_brochure = document.querySelector("[data-brochure-download]");
const duplex_gallery = document.querySelector(".duplex-gallery");

// salvăm pozițiile originale
const intro_parent = duplex_intro.parentNode;
const intro_next = duplex_intro.nextSibling;

const button_parent = duplex_btn_brochure.parentNode;
const button_next = duplex_btn_brochure.nextSibling;

function duplexMoveElements() {
    if (window.innerWidth < 992) {
        // mutăm intro primul
        if (!duplex_gallery.contains(duplex_intro)) {
            duplex_gallery.insertBefore(duplex_intro, duplex_gallery.firstChild);
        }
        // mutăm butonul la sfârșit
        if (!duplex_gallery.contains(duplex_btn_brochure)) {
            duplex_gallery.appendChild(duplex_btn_brochure);
        }
    } else {
        // revenire intro
        if (intro_next) {
            intro_parent.insertBefore(duplex_intro, intro_next);
        } else {
            intro_parent.appendChild(duplex_intro);
        }
        // revenire button
        if (button_next) {
            button_parent.insertBefore(duplex_btn_brochure, button_next);
        } else {
            button_parent.appendChild(duplex_btn_brochure);
        }
    }
}

duplexMoveElements();

window.addEventListener("resize", duplexMoveElements);
// END move

// Adăugarea unui input ascuns în formularul din popup pentru descărcarea broșurii
$('.section-3').on('click', '.btn[data-brochure-download]', function () {
    const file_url = $(this).attr('data-brochure-download');

    const input = $('<input>', {
        type: 'hidden',
        name: 'brochure',
        value: file_url,
        class: 'brochure-input'
    });

    $('#popup form').prepend(input);
});

// Eliminarea inputului ascuns atunci când popup-ul este închis
$('#popup').on('hidden.bs.modal', function () {
    $(this).find('.brochure-input').remove();
});

Fancybox.bind('[data-fancybox]', {
    Toolbar: {
        display: {
            // left: ["counter"],
            // middle: [],
            right: ["zoomIn", "fullscreen", "thumbs", "close"],
        },
    },
});

let currentType = 'b'; // Default duplex type
let currentGallery = 'facade'; // Default gallerytab

$('.duplexes-header__types').on('click', '.btn[data-type]', function () {
    $('.duplexes-header__types .btn').removeClass('active');
    $(this).addClass('active');

    currentType = $(this).data('type');
    renderDuplex();
});

$('.duplex-gallery__tabs').on('click', '.btn[data-gallery]', function () {
    $('.duplex-gallery__tabs .btn').removeClass('active');
    $(this).addClass('active');

    currentGallery = $(this).data('gallery');
    renderGallery();
});

function renderDuplex() {
    // Matricea de duplexuri este definită în fișierul index.twig
    const duplex = duplexesData.duplexes.find(d => d.type === currentType);

    if (!duplex) return;

    $('.btn[data-brochure-download]').attr('data-brochure-download', duplex.floorplans);
    $('#popup-download-brochure form ').find('input[name="brochure"]');
    $('#duplex-title').text(duplex.title);
    $('#duplex-description').html(
        duplex.description.map(p => `<span>${p}</span>`).join('')
    );
    $('#duplex-levels').text(duplex.specs.levels);
    $('#duplex-bedrooms').text(duplex.specs.bedrooms);
    $('#duplex-parking').text(duplex.specs.parking);
    $('#duplex-yard').text(duplex.specs.yard);
    $('#duplex-ground-surface').text(duplex.specs.ground_surface);
    $('#duplex-floor-surface').text(duplex.specs.floor_surface);
    $('#duplex-total-surface').text(duplex.specs.total_surface);

    renderGallery();
}

function renderGallery() {
    const duplex = duplexesData.duplexes.find(d => d.type === currentType);
    const gallery = duplex.gallery[currentGallery];

    swiper_section_3.removeAllSlides();

    swiper_section_3.appendSlide(
        gallery.map(img => {
            const file_name = img.split('/').pop(); // ex: fatad-1.jpg
            const base_path = img.substring(0, img.lastIndexOf('/')); // path fără fișier

            return `<div class="swiper-slide">
                <a href="${base_path}/big/${file_name}" data-fancybox="gallery">
                <img src="${img}" alt="">
                </a>
            </div>`;
        })
    );

    swiper_section_3.update();
}

const swiper_section_3 = new Swiper('#section-3 .swiper', {
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 16,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
    }
});

const swiper_section_4 = new Swiper('#section-4 .swiper', {
    breakpoints: {
        0: {
            spaceBetween: 20
        },
        992: {
            spaceBetween: 32
        },
        1200: {
            spaceBetween: 36
        },
        1400: {
            spaceBetween: 40
        }
    },
    grabCursor: true,
    slidesPerView: 'auto',
    //spaceBetween: 40,
    autoHeight: true,
    pagination: {
        el: '.swiper-pagination',
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    }
});

const swiper_section_5 = new Swiper('#section-5 .swiper', {
    centeredSlides: true,
    grabCursor: true,
    slidesPerView: 'auto',
    // initialSlide: Math.floor(document.querySelectorAll('#section-5 .swiper-slide').length / 2),
    initialSlide: 2,
    speed: 600,
    effect: 'creative',
    creativeEffect: {
        prev: {
            translate: ['-119%', 0, -500],
        },
        next: {
            translate: ['119%', 0, -500],
        },
    },
    pagination: {
        el: '.swiper-pagination',
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    }
});

$('.section-1 .btn-custom, .section-3 .btn-custom, .section-6 .btn-custom').on('click', function (e) {
    dataLayer.push({ 'event': 'begin_form' });
});

var form_start = false;
$('form .form-control').focus(function () {
    if (form_start == false) {
        dataLayer.push({ 'event': 'form_start' });
        form_start = true;
    }
});

$('form').submit(function (e) {
    e.preventDefault();

    const btn_submit = $(this).find('button[type="submit"]');
    btn_submit.attr('disabled', true);

    dataLayer.push({ 'event': 'form_submit' });

    const alert = (message, type) => {
        let wrapper = document.createElement('div')
        wrapper.innerHTML = [
            `<div class="alert alert-${type} alert-dismissible" role="alert">`,
            `   <div>${message}</div>`,
            '   <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>',
            '</div>'
        ].join('');

        $('.form-response').append(wrapper);
    }

    $.ajax({
        url: $(this).attr('action'),
        method: $(this).attr('method'),
        data: $(this).serialize() + '&submit=submit',
        dataType: 'json',
    }).done(function (response) {
        if ($('#popup').hasClass('show')) {
            bootstrap.Modal.getInstance($('#popup')).hide();

            const brochure = $('#popup form').find('input[name="brochure"]');

            let link = document.createElement('a');
            link.href = brochure.val();
            link.download = brochure.val().substr(brochure.val().lastIndexOf('/') + 1);
            link.click();
            link.remove();
        }

        if (response == true) {
            alert('Mesajul a fost expediat cu succes!', 'success');
            dataLayer.push({ 'event': 'lead_generated' });
        } else {
            alert('Eroare în procesarea formularului. Vă rugăm să încercați din nou mai târziu.', 'warning');
        }
    }).fail(function (error) {
        alert('Eroare în timpul expedierii formularului. Vă rugăm să încercați din nou.', 'danger');
    }).always(function () {
        btn_submit.attr('disabled', false);
    });

    this.reset();
});

// * Animations
gsap.registerPlugin(ScrollTrigger);

// gsap.to('.hero-media img', {
//     scale: 1.15,
//     duration: 10,
//     ease: 'power1.out'
// });

gsap.to('.hero-media img', {
    y: 180,
    ease: 'none',
    scrollTrigger: {
        trigger: '.hero-content',
        start: 'top top',
        end: 'bottom top',
        scrub: true
    }
});

// ScrollTrigger.create({
//     trigger: ".duplex-details",
//     start: "top top+=100",
//     end: () => "+=" + (document.querySelector(".duplex-details").offsetHeight - document.querySelector(".duplex-gallery").offsetHeight),
//     pin: ".duplex-gallery",
//     // pinSpacing: false,
// });

// ScrollTrigger.matchMedia({
//     // DOAR desktop (> 991px)
//     "(min-width: 992px)": function () {

//         ScrollTrigger.create({
//             trigger: ".duplex-details",
//             start: "top top+=100",
//             end: () => "+=" + (
//                 document.querySelector(".duplex-details").offsetHeight -
//                 document.querySelector(".duplex-gallery").offsetHeight
//             ),
//             pin: ".duplex-gallery",
//             scrub: true,
//             invalidateOnRefresh: true,
//         });
//     },

//     // optional: cleanup pe mobile
//     "(max-width: 991px)": function () {
//         ScrollTrigger.getAll().forEach(st => st.kill());
//     }
// });

gsap.utils.toArray('.section-title, .section-6 .btn-custom, .section-6 .location-item').forEach((element) => {
    ScrollTrigger.create({
        trigger: element,
        start: "top 90%",
        onEnter: () => {
            element.classList.remove('invisible');
            element.classList.add('animate__animated', 'animate__fadeIn');
        }
    });
});

gsap.utils.toArray('.section-1 .hero-subtitle, .section-1 .hero-title, .section-1 .btn-custom').forEach((element) => {
    ScrollTrigger.create({
        trigger: element,
        start: "top 90%",
        onEnter: () => {
            element.classList.remove('invisible');
            element.classList.add('animate__animated', 'animate__fadeInUp');
        }
    });
});

gsap.utils.toArray('.section-1 .hero-badge, .section-2 .feature').forEach((element) => {
    ScrollTrigger.create({
        trigger: element,
        start: "top 90%",
        onEnter: () => {
            element.classList.remove('invisible');
            element.classList.add('animate__animated', 'animate__fadeInRight');
        }
    });
});